
define('text!templates/modules/calendar/calendar-item-panel-content.html',[],function () { return '<div class="panel-body calendar-item-panel-content">\n    <ul class="menu-actions nav nav-pills"></ul>\n    <div class="content">\n        {{> content}}\n    </div>\n</div>\n';});

